import { Component, OnInit, AfterContentInit } from '@angular/core';
import { ContactModel } from '@models/index';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, never, Observable } from 'rxjs';

import { ContactsFacadeService } from '@services/contacts/contacts-facade.service';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { emptyContactModel } from '@utilities/data-utils';
import { RouterFacadeService } from '@services/router-facade.service';
import Swal from 'sweetalert2';
import { CampaignsFacadeService } from '@services/campaigns/campaigns-facade.service';


@Component({
  selector: 'app-dots',
  templateUrl: './dots.component.html',
  styleUrls: ['./dots.component.sass']
})
export class DotsComponent implements OnInit, AfterContentInit {
  _subs: Subscription = never().subscribe();

  selectedLocation$ = this.locationFacadeService.getCurrentLocation$()

  emptyContact: ContactModel = emptyContactModel();
  contactAdded$: Observable<boolean> = this.contactsFacadeService.getContactAdded$()

  bulkContactsList: ContactModel[] = [];
  bulkHeadersList: string[] = [];

  constructor(
    private modalService: NgbModal,
    private contactsFacadeService: ContactsFacadeService,
    private routerFacadeService: RouterFacadeService,
    private locationFacadeService: LocationsFacadeService,
    private campaignsFacadeService: CampaignsFacadeService,
  ) {
  }

  ngOnInit() {
    this.contactsFacadeService.setContactAdded(false)
  }

  ngAfterContentInit() {
    this._subs.add(
      this.contactAdded$.subscribe(contactAdded => {
        if (contactAdded)
          this.contactsFacadeService.setContactAdded(false);
      })
    );
  }

  createContact(contact: ContactModel) {
    const newContact = { ...contact, email: contact.email.toLowerCase().trim() }
    this.contactsFacadeService.createContact({ contact:newContact, campaignId: contact.campaignId })
  }
  newBulkFile(contacts: ContactModel[]) {
    this.bulkContactsList = contacts;
  }

  navigateTo(pathUrl: string) {
    this.routerFacadeService.navigateTo$(pathUrl)
  }

  bulkHeaders(headers: string[]) {
    this.bulkHeadersList = headers;
  }
  searchCampaign(event: any) {
    this.campaignsFacadeService.getLocationCampaignsBasicInfo();
  }
}
